import { AppConfig } from 'common/interfaces';

const DEPLOYMENT_ENV = (process.env.REACT_APP_DEPLOYMENT_ENV as 'dev' | 'stage' | 'prod') || 'dev';

type IBuildConfig = {
  codePushDeploymentKey: string;
};
let BuildConfig = {} as IBuildConfig;

if (DEPLOYMENT_ENV === 'prod') {
  // Silence noisy console methods in production; console.error is left intact so real errors stay visible.
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.debug = () => {};
}

// PostHog project API key (public, safe to commit). Analytics is disabled when the key is empty.
const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || '';
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

const prod = {
  envType: 'prod',
  version: 2.0,
  api: {
    rest: 'https://reports.xprotean.com',
  },
  appConfig: {
    appVersionId: '1',
  },
  analytics: {
    enabled: true,
    posthogKey: POSTHOG_KEY,
    posthogHost: POSTHOG_HOST,
  },
} as ConfigType;

const stage = {
  envType: 'stage',
  version: 2.0,
  api: {
    rest: 'https://reports.binarytechlab.com',
  },
  appConfig: {
    appVersionId: '1',
  },
  analytics: {
    enabled: true,
    posthogKey: POSTHOG_KEY,
    posthogHost: POSTHOG_HOST,
  },
} as ConfigType;

const dev = {
  envType: 'dev',
  version: 1,
  api: {
    rest: 'https://reports.xprotean.com',
  },
  appConfig: {
    appVersionId: '1',
  },
  analytics: {
    enabled: true,
    posthogKey: POSTHOG_KEY,
    posthogHost: POSTHOG_HOST,
  },
} as ConfigType;

type ConfigType = {
  envType: 'prod' | 'dev' | 'stage';
  api: {
    rest: string;
  };
  version: number;
  appConfig: AppConfig;
  analytics: {
    enabled: boolean;
    posthogKey: string;
    posthogHost: string;
  };
};

type Stages = {
  [key: string]: ConfigType;
};

const stages: Stages = { dev, stage, prod };

export const config = stages[DEPLOYMENT_ENV];
export { BuildConfig };
